/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type CeproDocsImportDocCreateRequest = {} | null | undefined;
export type CeproDocsImportDocCreateResponse = any;

export type CeproDocsImportDocCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/cepro_docs/{id}/import_doc/
 *
 * ```yaml
 * operationId: cepro_docs_import_doc_create
 * tags:
 *   - cepro_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const ceproDocsImportDocCreateOperation = ({ id, ...rest }: CeproDocsImportDocCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/cepro_docs/${id}/import_doc/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/cepro_docs/{id}/import_doc/' };
  };

/**
 * POST /dmx-server/cepro_docs/{id}/import_doc/
 *
 * ```yaml
 * operationId: cepro_docs_import_doc_create
 * tags:
 *   - cepro_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const ceproDocsImportDocCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CeproDocsImportDocCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = ceproDocsImportDocCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
